import styled from "styled-components";

export const FormStyle = styled.form`
    width: 100%;
`;